var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", staticStyle: { "margin-bottom": "30px" } },
    [
      _c("div", { staticClass: "row", staticStyle: { padding: "20px" } }, [
        _c("div", {
          staticClass:
            "mx-auto bg-white rounded p-5 lpp col-6 col-md-6 d-none d-sm-block",
          staticStyle: {
            "background-image": "url('img/hero2.jpg')",
            "background-position": "center",
            "background-size": "cover",
            "background-repeat": "no-repeat",
            height: "550px",
          },
        }),
        _c("div", { staticClass: "col-lg-5 px-3 col-md-8" }, [
          _c("div", { staticClass: "card mx-auto p-1" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("h3", { staticClass: "text-center" }, [
                _vm._v("Identidade Verificada"),
              ]),
              _c("img", {
                staticClass: "img-fluid d-block mx-auto py-2",
                attrs: { src: "/img/shield.png" },
              }),
              _c("p", [
                _vm._v(
                  " Confirmarmos seus dados e sua identidade foi verificada. Agora você está pronto(a) para começar a negociar suas pendências no portal. Seja bem vindo(a). "
                ),
              ]),
              _c("div", { staticClass: "col-12 text-center" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "btn btn-secondary btn-lg home-form mx-2 my-2 quicks py-3 px-3",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.inicio()
                      },
                    },
                  },
                  [_vm._v("Começar a usar")]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }